<template>
  <div class="card p-3">
    <TableViewBo :columns="tableColumns" :items="items" :pagination="pagination" :sort-field="sortField"
      :sort-direction="sortDirection" :show-search="false" :has-actions="false" :selectable="true"
      :all-selected="allSelected" @select-all="toggleSelectAll" @page-change="$emit('page-change', $event)"
      @sort="$emit('sort', $event)">
      <template #new="{ item }">
        <span v-if="isLastUoc(item.id)" class="new-dot"></span>
      </template>
      <!-- Checkbox per riga -->
      <template #selected="{ item }">
        <input type="checkbox" :value="item.id" v-model="selectedQuestions" @change="onSelectionChange">
      </template>

      <!-- Link ID -->
      <!--<template #id="{ item }">
        <a href="#" class="text-decoration-none fw-semibold"
          @click.prevent="$emit('change-view', 'SessioneUOCView', item.id)">
          #{{ item.id }}
        </a>
      </template>-->

      <template #id="{ item }">
        <a href="#" class="text-decoration-none" :class="{ 'fw-bold': isLastUoc(item.id) }"
          @click.prevent="openUoc(item.id)">
          #{{ item.id }}
        </a>
      </template>

      <!-- DATA -->
      <template #date="{ item }">
        <span class="text-center">{{ formatDate(item.date) }}</span>
      </template>

      <!-- OGGETTO -->
      <template #object="{ item }">
        <span :title="item.object">
          {{ truncate(item.object, 40) }}
        </span>
      </template>

      <!-- DESCRIZIONE -->
      <template #notes="{ item }">
        <span :title="item.notes">
          {{ truncate(item.notes, 60) }}
        </span>
      </template>

      <!-- TIPO -->
      <template #tipo="{ item }">
        <span class="text-center">{{ item.tipo }}</span>
      </template>

      <!-- PARERI DISCUSSI -->
      <template #questions_count="{ item }">
        <span class="text-center">{{ item.questions_count }}</span>
      </template>

      <template #empty>
        Nessuna UOC presente nello storico.
      </template>
    </TableViewBo>
  </div>
</template>

<script>
import TableViewBo from '../../../../components/common/TableViewBo.vue';

export default {
  name: 'UOCArchiveTable',
  components: { TableViewBo },
  props: {
    items: { type: Array, required: true },
    pagination: Object,
    sortField: String,
    sortDirection: String
  },
  data() {
    return {
      selectedQuestions: [],
      allSelected: false,
    };
  },
  watch: {
    selectedQuestions(newVal) {
      this.allSelected = newVal.length === this.items.length && this.items.length > 0;
    },
    items: {
      immediate: true,
      handler(newItems) {
        this.selectedQuestions = [];
        this.allSelected = false;
      }
    }
  },
  computed: {
    tableColumns() {
      return [
        { key: 'new', label: '', width: '2%' },
        { key: 'selected', label: '', width: '3%' },
        { key: 'id', label: 'ID', sortable: true, width: '5%' },
        { key: 'date', label: 'DATA', sortable: true, width: '5%' },
        { key: 'tipo', label: 'TIPO', sortable: true, width: '10%' },
        { key: 'object', label: 'OGGETTO', sortable: true, width: '28%' },
        { key: 'notes', label: 'DESCRIZIONE', sortable: true, width: '30%' },
        { key: 'questions_count', label: 'PARERI DISCUSSI', sortable: true, width: '7%' }
      ];
    }
  },
  methods: {
    isLastUoc(id) {
      const stored = localStorage.getItem('last_uoc_id');
      if (!stored) return false;

      const lastUocId = Number(stored);
      if (Number.isNaN(lastUocId)) return false;

      return lastUocId === id;
    },
    openUoc(id) {

      if (this.isLastUoc(id)) {
        localStorage.removeItem('last_uoc_id');
      }

      this.$emit('change-view', 'SessioneUOCView', id);
    },
    formatDate(d) {
      if (!d) return '-';
      return new Date(d).toLocaleDateString('it-IT');
    },
    truncate(text, len) {
      if (!text) return '—';
      return text.length > len ? text.slice(0, len) + '…' : text;
    },
    onSelectionChange() {
      // Aggiorna checkbox generale
      this.allSelected = this.selectedQuestions.length === this.items.length;
      this.$emit('update:selected-questions', this.selectedQuestions);
    },
    toggleSelectAll(checked) {
      this.allSelected = checked;
      this.selectedQuestions = checked ? this.items.map(item => item.id) : [];
      this.$emit('update:selected-questions', this.selectedQuestions);
    }
  }
}
</script>
<style scoped>
.new-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  background-color: red;
  border-radius: 50%;
}
</style>
